const authBody = () => {
  try {
    const raw = localStorage.getItem('userdata')
    const parsed = raw ? JSON.parse(raw) : {}
    return { userid: parsed.id || '', pid: parsed.pid || '' }
  } catch (err) {
    return { userid: '', pid: '' }
  }
}

const failText = (data) => {
  const msg = data && (data.msg || data.error)
  if (!msg) return 'Request failed'
  if (typeof msg === 'string') return msg
  return msg.sqlMessage || msg.message || 'Request failed'
}

const read = async (res) => {
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(failText(data))
  return data
}

export const fetchCommunities = async () => {
  const res = await fetch('/api/communities')
  const data = await read(res)
  return data.communities || []
}

const memStore = () => {
  try {
    return JSON.parse(localStorage.getItem('pinweelo-community-mine') || '{}')
  } catch (err) {
    return {}
  }
}

const memKey = (userid, communityId) => `${userid}::${communityId}`

export const rememberedMine = (communityId, userid) => {
  const uid = userid || authBody().userid
  if (!communityId || !uid) return ''
  const saved = memStore()[memKey(uid, communityId)] || ''
  return saved === 'none' ? '' : saved
}

export const rememberMine = (communityId, userid, type) => {
  const uid = userid || authBody().userid
  if (!communityId || !uid || !type) return
  const all = memStore()
  all[memKey(uid, communityId)] = type
  try {
    localStorage.setItem('pinweelo-community-mine', JSON.stringify(all))
  } catch (err) {}
}

export const fetchCommunity = async (id, userid) => {
  const uid = userid || authBody().userid
  const q = uid ? `?userid=${encodeURIComponent(uid)}` : ''
  const res = await fetch(`/api/communities/${encodeURIComponent(id)}${q}`)
  const data = await read(res)
  if (data && data.community && data.community.id) {
    // Keep the saved answer in step with the server (including "not a member" and "waiting").
    rememberMine(data.community.id, uid, data.mine || 'none')
  }
  return data
}

export const fetchUserCommunities = async (userid) => {
  if (!userid) return []
  const res = await fetch(`/api/communities/by-user/${encodeURIComponent(userid)}`)
  const data = await read(res)
  return data.communities || []
}

export const JOIN_RULES = [
  { id: 'admin', label: '1. Admin only', text: 'Only the admin is notified, and the admin accepts the new member.' },
  { id: 'rand5', label: '2. 5 random members', text: 'Five random members are notified, and they accept the new member.' },
  { id: 'rand10', label: '3. 10 random members', text: 'Ten random members are notified, and they accept the new member.' },
  { id: 'all', label: '4. Every member', text: 'Every member is notified, and every member has to accept.' },
  { id: 'any5', label: '5. Any 5 members', text: 'Every member is notified, but only 5 have to accept.' },
  { id: 'any10', label: '6. Any 10 members', text: 'Every member is notified, but only 10 have to accept.' }
]

export const joinRuleText = (id) => {
  const found = JOIN_RULES.find((rule) => rule.id === id)
  return found ? found.text : 'A member needs to accept you.'
}

export const createCommunity = async ({ name, bio, img, joinRule }) => {
  const res = await fetch('/api/communities', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...authBody(), name, bio, img, joinRule: joinRule || 'admin' })
  })
  const data = await read(res)
  if (!data.community) throw new Error('Could not create community')
  rememberMine(data.community.id, authBody().userid, data.mine || 'a')
  return data.community
}

export const joinCommunity = async (id, extra = {}) => {
  const res = await fetch(`/api/communities/${encodeURIComponent(id)}/join`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...authBody(), ...extra })
  })
  const data = await read(res)
  if (data && data.mine) rememberMine(id, extra.userid || authBody().userid, data.mine)
  return data
}

export const editCommunity = async (id, fields) => {
  const res = await fetch(`/api/communities/${encodeURIComponent(id)}/edit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...authBody(), ...fields })
  })
  const data = await read(res)
  if (!data.community) throw new Error('Could not save the community')
  return data.community
}

export const voteCommunityJoin = async (id, applicant, accept = true) => {
  const res = await fetch(`/api/communities/${encodeURIComponent(id)}/vote`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...authBody(), applicant, accept })
  })
  return read(res)
}

export const kickCommunityMember = async (id, member) => {
  const res = await fetch(`/api/communities/${encodeURIComponent(id)}/kick`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...authBody(), member })
  })
  return read(res)
}

export const shareToCommunity = async (id, body) => {
  const res = await fetch(`/api/communities/${encodeURIComponent(id)}/share`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...authBody(), ...body })
  })
  return read(res)
}

export const startCommunityStream = async (id) => {
  const res = await fetch(`/api/communities/${encodeURIComponent(id)}/stream`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(authBody())
  })
  const data = await read(res)
  if (!data.room) throw new Error(data.msg || 'Could not start stream')
  return data.room
}

export const communityIdOf = (post) => {
  const tagged = String(post && post.communityid || '').trim()
  if (tagged) return tagged
  const link = String(post && (post.link || post.userLink) || '')
  if (link.startsWith('c:')) return link.slice(2)
  return ''
}
